
// src/components/TZ/patentOblRes/SearchForm.jsx
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Form,
  Input,
  InputNumber,
  Button,
  message,
} from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';

import { useSocketContext } from '../../../sockets/SocketContext';
import { setWipoLastSearchQuery } from '../../../store/wipoSlice';
import { setLastSearchQuery, setFormValues } from '../../../store/tz/reducer';
import MktuClassSelector from '../../common/MktuClassSelector';
import normalizeMktu from '../../../utils/normalizeMktu';

const SearchForm = ({ setLocalState }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const savedValues = useSelector((s) => s.tz.forms.patentObl);
  const { createNewTaskOnServer } = useSocketContext();

  const handleFinish = async (values) => {
    const { patentObl, quantity, mktu } = values;
    const normalizedMktu = normalizeMktu(mktu);

    // сохраняем последний запрос
    dispatch(setLastSearchQuery(patentObl));
    
    // Обновляем локальное состояние, если передан setLocalState
    if (setLocalState) {
      setLocalState(prev => ({
        ...prev,
        searchQuery: patentObl,
        quantity,
        mktu
      }));
    }

    /* ───────── создаём две задачи через сокет ───────── */
    const taskTZ  = { patentObl, quantity, mktu };
    const taskReq = { patentOblRequests:patentObl, quantity, mktu };
    const wipoTask = { wipoObl: patentObl, quantity, mktu: normalizedMktu };

    dispatch(setWipoLastSearchQuery(patentObl));
    const jobs = [
      { desc: taskTZ,  type: 'patentObl',         label: 'ТЗ' },
      { desc: taskReq, type: 'patentOblRequests', label: 'заявки' },
      { desc: wipoTask,type: 'wipoObl',           label: 'WIPO' },
    ];
    const results = await Promise.all(jobs.map(j => new Promise((resolve) => {
      createNewTaskOnServer(j.desc, j.type, (err) => resolve({ label: j.label, err }));
    })));
    const failed = results.filter(r => r.err);
    if (failed.length === 0) {
      message.success('Все запросы отправлены');
    } else {
      failed.forEach(r => message.error(`Не удалось создать задачу ${r.label}`));
    }
  };

  useEffect(() => {
    form.setFieldsValue(savedValues);
  }, [form, savedValues]);

  return (
    <Form
      form={form}
      layout="inline"
      onFinish={handleFinish}
      onValuesChange={(_, all) => dispatch(setFormValues({ formKey: 'patentObl', values: all }))}
      style={{ marginBottom: 16, flexWrap: 'wrap' }}
    >
      <Form.Item
        name="patentObl"
        label="Правообладатель"
        rules={[{ required: true, message: 'Введите правообладателя' }]}
      >
        <Input placeholder="Правообладатель" style={{ width: '100%', maxWidth: 280, minWidth: 0 }} />
      </Form.Item>

      <Form.Item name="mktu" label="МКТУ">
        <MktuClassSelector placeholder="Классы" />
      </Form.Item>

      <Form.Item name="quantity" label="Кол-во" initialValue={20}>
        <InputNumber min={1} max={200} style={{ width: 80 }} />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" icon={<FileSearchOutlined />}>
          Найти
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SearchForm;
